import { useVersionCheck } from "@/app/hooks/useVersionCheck";
import { useEffect, useState } from "react";

const VersionCheck = () => {
  const currentVersion = BUILD_DATE;
  const latestVersion = useVersionCheck();
  const [isNewVersionAvailable, setIsNewVersionAvailable] = useState(false);

  useEffect(() => {
    if (latestVersion && currentVersion !== latestVersion) {
      setIsNewVersionAvailable(true);
    }
  }, [currentVersion, latestVersion]);

  if (!isNewVersionAvailable) {
    return null;
  }

  return (
    <div
      className="tw-fixed tw-bottom-8 tw-left-8 tw-z-50 tw-cursor-pointer tw-rounded-md tw-border tw-bg-white tw-p-4 tw-text-sm tw-shadow-sm"
      onClick={async () => {
        if ("serviceWorker" in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          for (let registration of registrations) {
            await registration.unregister();
          }
        }
        window.location.reload();
      }}
    >
      A new version is available. Please save your work and click here to refresh.
    </div>
  );
};

VersionCheck.displayName = "VersionCheck";

export default VersionCheck;
